import * as Yup from 'yup';
import { isValidEmail } from '../components/email-chips-input';
import { SOURCE_OPTIONS, WINDOW_OPTIONS, CADENCE_OPTIONS } from '../constants/scheduledReports.constants';

// Derive the allowed values from the same option lists that populate the
// dropdowns, so validation can never drift from what the UI offers — adding a
// report type to SOURCE_OPTIONS is enough. A hardcoded source list here is
// exactly what blocked the new activity reports client-side (the form rejected
// them before the request ever reached the API).
const SOURCE_VALUES = SOURCE_OPTIONS.map((o) => o.value);
const WINDOW_VALUES = WINDOW_OPTIONS.map((o) => o.value);
const CADENCE_VALUES = CADENCE_OPTIONS.map((o) => o.value);

export const scheduledReportSchema = Yup.object().shape({
    name: Yup.string().trim().required('Name is required').max(120, 'Name is too long'),
    source: Yup.string().oneOf(SOURCE_VALUES).required('Pick a report source'),
    window: Yup.string().oneOf(WINDOW_VALUES).required('Pick a date window'),
    cadence: Yup.string().oneOf(CADENCE_VALUES).required('Pick a cadence'),
    recipients: Yup.array()
        .of(Yup.string())
        .min(1, 'Add at least one recipient email')
        .test('all-valid', 'One or more recipients are not valid emails', (list) =>
            (list ?? []).every((e) => typeof e === 'string' && isValidEmail(e)),
        ),
    timeOfDay: Yup.string().matches(/^\d{2}:\d{2}$/, 'Pick a time').required('Pick a time'),
    timezone: Yup.string().required('Pick a timezone'),
    dayOfWeek: Yup.number().min(0).max(6),
    dayOfMonth: Yup.number().min(1).max(28),
    active: Yup.boolean(),
    filters: Yup.object({
        groupIds: Yup.array().of(Yup.string()),
        teamIds: Yup.array().of(Yup.string()),
        tagIds: Yup.array().of(Yup.string()),
    }).optional(),
    reportTimezone: Yup.string().optional(),
});
